import {useNavigate} from "react-router-dom";
import Box from "../../components/common/Box";
import API from "@/api";
import RotaForm from "./_components/RotaForm";

const AddRota = () => {
  const navigate = useNavigate();

  const handleCreateRota = async (data) => {
    return API.rotas.add(data).then(() => {
      navigate(`../`)
    });
  };

  return (
    <div className="p-4">
      <Box title="Add Rota">
        <RotaForm
          onSubmit={handleCreateRota}
          onCancel={() => {
            navigate(`../`)
          }}
        />
      </Box>
    </div>
  );
};
export default AddRota;